import { AfterViewChecked, Directive, ElementRef, HostListener } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

// desabilita o matTooltip no mesmo elemento quando o texto não está truncado
// (ellipsis), evitando mostrar o tooltip quando ele não acrescenta nada
@Directive({
  selector: '[matTooltip][appTruncateTooltip]',
})
export class TruncateTooltipDirective implements AfterViewChecked {
  private lastWasTruncated: boolean | null = null;

  constructor(private el: ElementRef<HTMLElement>, private tooltip: MatTooltip) {}

  @HostListener('window:resize')
  onResize(): void {
    this.updateTooltipState();
  }

  ngAfterViewChecked(): void {
    this.updateTooltipState();
  }

  private updateTooltipState(): void {
    const element = this.el.nativeElement;
    const isTruncated = element.scrollWidth > element.clientWidth;
    if (isTruncated === this.lastWasTruncated) return;
    this.lastWasTruncated = isTruncated;
    this.tooltip.disabled = !isTruncated;
  }
}
